import { useQuery } from '@tanstack/react-query';
import { classesApi } from '../../api/classes.api';
import { MINUTE } from '@shared/utils';

export const useGetClassTypeAndPlace = () => {
  return useQuery({
    queryKey: ['class-type-class-place'],
    queryFn: () => classesApi.getClassTypeAndPlace(),
    staleTime: 60 * MINUTE,
    meta: { persist: true },
  });
};
